import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { AddJitApprovalPolicy } from 'containers/Jit/Setup/Components/ApprovalPolicy/AddJitApprovalPolicy';
import { actions } from 'containers/Jit/Setup/slice';

export const EditJITApprovalPolicy = () => {
  const dispatch = useDispatch();
  const params = useParams<{ uuid: string }>();
  useEffect(() => {
    if (!!params.uuid)
      dispatch(actions.getApprovalPolicy({ q: { policyId: params.uuid } }));
  }, [params.uuid, dispatch]);

  return <AddJitApprovalPolicy action="Update" />;
};
